import {
    SchedulerItemProps,
    SchedulerSlotProps,
} from '@progress/kendo-react-scheduler'
import { useAppContext } from 'context/AppContext'
import { useCallback } from 'react'
import { addAlpha, classNames } from 'utils/dom-helpers'

export interface GCalSlot extends SchedulerSlotProps {
    viewDay(date: Date): void
    viewDayItem(data: unknown): void
    className?: string
    active_week: any
}

export function SchedulerSlot(p: GCalSlot) {
    const { translations } = useAppContext()
    const { items, start, viewDay, active_week } = p

    function slideOpen(date: Date) {
        viewDay(date)
    }

    function SlotItem(item: SchedulerItemProps, idx: number) {
        const { title, slots, primary_hex } = item.dataItem
        const [name, place] = (title || '').split(' @ ')

        return idx < 2 ? (
            <div
                className={`g6-scheduler-slot w-full h-full ${p.className}`}
            >
                <p
                    key={idx}
                    title={item.title || ''}
                    onClick={() => {
                        p.viewDayItem(item)
                    }}
                    style={{
                        backgroundColor: primary_hex
                            ? addAlpha(primary_hex, 0.2)
                            : 'red',
                        borderLeft: primary_hex
                            ? `4px solid ${primary_hex} `
                            : '',
                        color: primary_hex ? primary_hex : 'red',
                        filter: 'brightness(95%)',
                    }}
                    className="truncate text-ellipsis z-10 mb-1 py-1 px-2 rounded leading-none cursor-pointer"
                >
                    <strong>{name}</strong>
                    <span className=" rounded-full bg-primary-dark text-white bg-opacity-20 px-1 float-right">
                        {slots.available <= 0 ? (
                            <small>{translations.full || 'full'}</small>
                        ) : (
                            <small>{slots.taken}/{slots.max}</small>
                        )}
                    </span>
                    <br />
                    <small className="flex items-center">
                        <i className="feather-map-pin" />
                        &nbsp;
                        {place}
                    </small>
                </p>
            </div>
        ) : (
            ''
        )
    }

    const getHighlightStatus = useCallback(() => {
        const today = new Date()
        const slotDate = new Date(start)
        let shouldHighlight = false

        if (
            today.getDate() === slotDate.getDate() &&
            today.getMonth() === new Date(active_week).getMonth() &&
            today.getFullYear() === slotDate.getFullYear()
        )
            shouldHighlight = true
        return shouldHighlight
    }, [start])

    return (
        <div
            className={classNames(
                'flex w-full border-r border-b border-gray-100 relative flex-col overflow-auto',
                getHighlightStatus() ? 'bg-sky-100' : ''
            )}
        >
            <span className="block p-2 text-lg font-display w-full">
                {start.getDate()}
            </span>
            <div className="absolute top-10 flex flex-col w-full">
                {items.map(SlotItem)}
                {items.length > 2 ? (
                    <button
                        type="button"
                        className="inline-block w-16 text-left px-1"
                        onClick={(e) => {
                            slideOpen(start)
                        }}
                    >
                        + {items.length - 2} more&hellip;
                    </button>
                ) : (
                    ''
                )}
            </div>
        </div>
    )
}

export default SchedulerSlot
